var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.container,
    { tag: "component" },
    [
      _vm.title
        ? _c(
            "b-row",
            [
              _c("b-col", [
                _c("h3", { staticClass: "slice-title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "advanced-wysiwyg-content-region",
          attrs: {
            cols: _vm.getMinCols(1),
            "cols-sm": _vm.getMinCols(1),
            "cols-md": _vm.getMinCols(_vm.numColumns % 2 ? 3 : 2),
            "cols-lg": _vm.getMinCols(4),
            "cols-xl": _vm.getMinCols(4),
          },
        },
        _vm._l(_vm.numColumns, function (n) {
          return _c("b-col", {
            key: `wysiwyg-column-${n}`,
            domProps: { innerHTML: _vm._s(_vm.getColumnContent(n - 1)) },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }